import React from 'react';
import purchaseReducer, {defaultState} from "./purchase-reducer";
import actions from './purchase';

const PurchaseContext = React.createContext();

function usePurchaseContextValue() {

    const [state, dispatch] = React.useReducer(purchaseReducer, defaultState);

    const {selectedAddons, selectedSubscription, amount} = state;

    const setAddons = React.useCallback((addons) => dispatch(actions.setAddons(addons)), []);
    const setSubscription = React.useCallback((subscription) => dispatch(actions.setSubscription(subscription)), []);
    const setAmount = React.useCallback((amount) => dispatch(actions.setAmount(amount)), []);
    const addAddon = React.useCallback((addon) => dispatch(actions.addAddon(addon)), []);
    const removeAddon = React.useCallback((addon) => dispatch(actions.removeAddon(addon)), []);

    return React.useMemo(() => {
        return {
            state,
            selectedAddons, setAddons, addAddon, removeAddon,
            selectedSubscription, setSubscription,
            amount, setAmount,
        }
    }, [
        state,
        selectedAddons, setAddons, addAddon, removeAddon,
        selectedSubscription, setSubscription,
        amount, setAmount,
    ]);
}

function PurchaseProvider(props) {
    const value = usePurchaseContextValue();
    return <PurchaseContext.Provider value={value} {...props} />;
}

function usePurchase() {
    const context = React.useContext(PurchaseContext);
    if(!context) {
        throw new Error("usePurchase must be used within a PurchaseProvider");
    }
    return context;
}

export {
    PurchaseProvider,
    usePurchase,
}
